var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6752 4H5.32482C4.59327 4.0003 4.0003 4.59327 4 5.32482V26.6752C4.0003 27.4067 4.59327 27.9997 5.32482 28H16V18.5714H13.1313V15.1429H16V12.4107C16 9.31107 18.1498 7.62357 20.9189 7.62357C22.2437 7.62357 23.6687 7.72321 23.9998 7.76714V11.0045H21.7938C20.2873 11.0045 20.0002 11.717 20.0002 12.767V15.1429H23.5895L23.1207 18.5714H20.0002V28H26.6752C27.4067 27.9997 27.9997 27.4067 28 26.6752V5.32482C27.9997 4.59327 27.4067 4.0003 26.6752 4Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.8bbe7f2fb3361d5d3c4902dc44427274.svg";
export { ForwardRef as ReactComponent };